

















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { emptyPoint, getPointList, removePoint, addFocus, cancelFocus } from '@/api/videoDevice/index'
import videoPointForm from './form.vue'

@Component({
  components: { videoPointForm }
})
export default class VideoPointList extends Vue {
  public name = 'VideoPointList'
  @Prop({ default: 0 })
  public videoId: number = 0

  public listLoading: boolean = false
  public list: any = []
  // dynamic component
  public $refs!: {
    // pointCtrl: videoPointForm
  }
  public loadData() {
    if (this.videoId == 0) {
      this.$message({
        message: '视频设备未匹配，请检查',
        type: 'warning'
      })
      console.log('videoId为0，请赋值')
    } else {
      this.fetchData()
    }
  }
  public fetchData() {
    this.listLoading = true
    getPointList(this.videoId).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data
      }
      this.listLoading = false
    })
  }
  public getData() {
    return this.list
  }
  public addData() {
    this.showPointForm(0)
  }
  public addFocus(index: number) {
    var item = this.list[index]
    addFocus(item.Id).then(() => {
      item.IsFocus = true
      this.$message({ type: 'success', message: '已添加关注!' })
      // this.fetchData()
    })
  }
  public cancelFocus(index: number) {
    var item = this.list[index]
    cancelFocus(item.Id).then(() => {
      item.IsFocus = false
      this.$message({ type: 'success', message: '已取消关注!' })
      // this.fetchData()
    })
  }
  public doEdit(index: number) {
    var item = this.list[index]
    this.showPointForm(item.Id)
  }
  public doDel(id: number) {
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        removePoint(id).then(() => {
          this.$message({ type: 'success', message: '删除成功!' })
          this.fetchData()
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
  public showPointForm(pointId: number) {
    var info = {
      videoId: this.videoId,
      dataId: pointId
    }
    window.eventBus.$emit('openVideoPointForm', info)
  }
  public closePointForm() {
    console.log('closevideoPointForm')
  }
  public mounted() {
    window.eventBus.$on('submitVideoPointForm', (info: any) => {
      this.fetchData()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitVideoPointForm')
  }
}
